import React from "react";
import EvacuadosPorProvinciaTmp from '../../../containers/EvacuadosPorProvincia';
import { CAMPAIGN_2023 } from '../../../constants';

const EvacuadosPorProvincia = () => {

  return <EvacuadosPorProvinciaTmp campaign={CAMPAIGN_2023} year={2023}/>;
};

export default EvacuadosPorProvincia;
